'use client'

import { OurClientCarousel } from '@/components/molecules/carousel/our-client-carousel'
import Container from '@/components/templates/container/container'

interface Props {
  data: Klien
}

export const AboutOurClient = ({ data }: Props) => {
  return (
    <section className="py-9 lg:py-16">
      <Container className="max-w-[1100px] space-y-8">
        <header className="space-y-4 text-center">
          <h2 className="text-2xl font-extrabold lg:text-4xl text-primary-blue">
            Terpercaya oleh Organisasi Pilihan Sejak 2015
          </h2>
          <p className="text-sm lg:text-base">
            Easybiz telah dipercaya membantu ribuan Pendirian Perusahaan dan Pengurusan Perizinan Berusaha dari skala mikro,
            kecil, menengah, besar dan dengan beragam model bisnis.
          </p>
        </header>

        <OurClientCarousel data={data} variant="secondary" />
      </Container>
    </section>
  )
}
